 document.addEventListener("DOMContentLoaded", () => {
    const popcornIcons = document.querySelectorAll('.popcorn-icon');

    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY;

      popcornIcons.forEach(icon => {
        if (scrollPosition > 0) {
          const rotation = scrollPosition / 10;
          const scale = 1 + scrollPosition / 1000;
          icon.style.transform = `translateY(0) rotate(${rotation}deg) scale(${scale})`;
        } else {
          icon.style.transform = `translateY(100px)`;
        }
      });
    });
  });



$(".testimonial-custom-slider").slick({
    slidesToShow: 3,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,  
    arrows: true,
    prevArrow: '<button class="slick-prev custom-prev"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_2.png?v=1742898764"></button>',
    nextArrow: '<button class="slick-next custom-next"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_1_1.png?v=1742898765"></button>',
    responsive: [
        {
            breakpoint: 1024, 
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768, 
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

$(".tow-custom-testimonials-slider").slick({
    slidesToShow: 2,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,  
    arrows: true,
    prevArrow: '<button class="slick-prev custom-prev"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_2.png?v=1742898764"></button>',
    nextArrow: '<button class="slick-next custom-next"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_1_1.png?v=1742898765"></button>',
    responsive: [
        {
            breakpoint: 1024, 
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768, 
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

$(".cust-product-slider").slick({
    slidesToShow: 3,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,  
    arrows: true,
    prevArrow: '<button class="slick-prev custom-prev"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_2.png?v=1742898764"></button>',
    nextArrow: '<button class="slick-next custom-next"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_1_1.png?v=1742898765"></button>',
    responsive: [
        {
            breakpoint: 1024, 
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768, 
            settings: {
                slidesToShow: 1
            }
        }
    ]
});


$(".cust-logo-slider").slick({
    slidesToShow: 4,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,  // Enable pagination dots
    arrows: true, // Enable navigation arrows
    prevArrow: '<button class="slick-prev custom-prev"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_2_2.png?v=1744104807"></button>',
    nextArrow: '<button class="slick-next custom-next"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_1_3.png?v=1744104832"></button>',
    responsive: [
        {
            breakpoint: 1024, // Tablets
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768, // Mobile
            settings: {
                slidesToShow: 1
            }
        }
    ]
});


$(".cust-testimonials-slider").slick({
    slidesToShow: 3,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,  
    arrows: true,
    prevArrow: '<button class="slick-prev custom-prev"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_2_1.png?v=1743163670"></button>',
    nextArrow: '<button class="slick-next custom-next"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_1_2.png?v=1743163670"></button>',
    responsive: [
        {
            breakpoint: 1024, 
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768, 
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

$(".goodness-slider").slick({
    slidesToShow: 4,
    infinite: true,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    dots: true,  
    arrows: true,
    prevArrow: '<button class="slick-prev custom-prev" aria-label="Previous slide" role="button"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_2_2.png?v=1744104807"></button>',
    nextArrow: '<button class="slick-next custom-next" aria-label="Next slide" role="button"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_1_3.png?v=1744104832"></button>',
    responsive: [
        {
            breakpoint: 1024, 
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768, 
            settings: {
                slidesToShow: 1
            }
        }
    ]
});


$('.slider-content').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  arrows: true,
  fade: false,
  speed: 1000,
  asNavFor: '.slider-thumb',
  prevArrow: '<button class="slick-prev custom-prev"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_2_2.png?v=1744104807"></button>',
  nextArrow: '<button class="slick-next custom-next"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_1_3.png?v=1744104832"></button>',
});

$('.slider-thumb').slick({
  slidesToShow: 7,
  slidesToScroll: 7,
  asNavFor: '.slider-content',
  dots: false,
  arrows: false,
  centerMode: false,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});


function initMobileSlick() {
  if ($(window).width() <= 767) {
    if (!$('.our_customer_like').hasClass('slick-initialized')) {
      $(".our_customer_like").slick({
        slidesToShow: 2, // default for ≤767
        infinite: true,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: false,  
        arrows: true,
        prevArrow: '<button class="slick-prev custom-prev"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_2_2.png?v=1744104807"></button>',
        nextArrow: '<button class="slick-next custom-next"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_1_3.png?v=1744104832"></button>',
        responsive: [
          {
            breakpoint: 525,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    }
  } else {
    if ($('.our_customer_like').hasClass('slick-initialized')) {
      $('.our_customer_like').slick('unslick'); // remove slider on desktop
    }
  }
}

$(document).ready(function() {
  initMobileSlick();
});

$(window).on('resize', function() {
  initMobileSlick();
});



// Cart Upsell Logic
document.addEventListener('cart:updated', function(e) {
  const upsellBanner = document.getElementById('AjaxCartUpsell');
  if (!upsellBanner || !e.detail || !e.detail.cart) return;
  
  // Check if any cart item title contains "Gift"
  const hasGiftSize = e.detail.cart.items.some(item => 
    item.variant_title && item.variant_title.toLowerCase().includes('gift')
  );
  
  if (hasGiftSize) {
    upsellBanner.style.display = 'block';
  } else {
    upsellBanner.style.display = 'none';
  }
});

// Free Shipping Progress Bar Logic
document.addEventListener('cart:updated', function(e) {
  const fsProgress = document.getElementById('FreeShippingProgress');
  if (!fsProgress || !e.detail || !e.detail.cart) return;

  const thresholdInCents = 7500; // $75.00
  const currentTotalInCents = e.detail.cart.total_price;
  
  const defaultText = document.getElementById('fs-text-default');
  const successText = document.getElementById('fs-text-success');
  const amountAwaySpan = document.getElementById('fs-amount-away');
  const barFill = document.getElementById('fs-bar-fill');

  let percentage = (currentTotalInCents / thresholdInCents) * 100;
  if (percentage > 100) percentage = 100;
  
  barFill.style.width = percentage + '%';

  if (currentTotalInCents >= thresholdInCents) {
    defaultText.style.display = 'none';
    successText.style.display = 'block';
    barFill.style.background = '#4CAF50'; // Green when complete
  } else {
    defaultText.style.display = 'block';
    successText.style.display = 'none';
    barFill.style.background = '#e4b443'; // Brand yellow when incomplete
    
    const amountAway = (thresholdInCents - currentTotalInCents) / 100;
    amountAwaySpan.textContent = '$' + amountAway.toFixed(2);
  }
});


/* ----------------------------------------------------------------------------
 * CHECKOUT WATCHDOG  (added 2026-06-09)
 * WHY: The Zapiet "Store Pickup + Delivery" app intercepts the checkout button
 *      to inject the chosen pickup/delivery method, then redirects to the URL
 *      it builds (window.ZapietCheckoutUrl). Intermittently that redirect never
 *      fires, so the button keeps its loading spinner FOREVER and the customer
 *      is trapped — this is the "spinning at checkout" customers reported.
 * WHAT: After the checkout button is clicked, wait a few seconds. If the page
 *      is still on /cart (i.e. Zapiet stalled), recover the customer:
 *        1) complete checkout via Zapiet's own URL  -> keeps the delivery method
 *        2) if Zapiet is deliberately blocking       -> clear spinner + tell them
 *        3) last resort, native Shopify checkout      -> never leave them stuck
 * Purely defensive: it does nothing unless the checkout actually got stuck.
 * -------------------------------------------------------------------------- */
(function () {
  function onCheckoutClick(e) {
    var btn = e.target && e.target.closest && e.target.closest('.cart__checkout, [name="checkout"]');
    if (!btn) return;

    setTimeout(function () {
      // If we already left the cart for checkout, Zapiet did its job — do nothing.
      if (/\/checkout/.test(window.location.pathname)) return;

      var zapietUrl = (typeof window.ZapietCheckoutUrl === 'string') ? window.ZapietCheckoutUrl : '';
      if (zapietUrl) {
        // Zapiet prepared a checkout URL but never navigated — finish the job.
        window.location.href = zapietUrl;
      } else if (window.ZapietCheckoutEnabled === false) {
        // Zapiet is intentionally blocking (no valid pickup/delivery chosen):
        // clear the dead spinner and tell the customer what to do.
        btn.classList.remove('btn--loading');
        if (btn.removeAttribute) btn.removeAttribute('disabled');
        alert('Please choose a pickup or delivery option above, then click Check out again.');
      } else {
        // No Zapiet gate detected — fall back to native Shopify checkout.
        window.location.href = '/checkout';
      }
    }, 6000);
  }

  // Capture phase so we still run even if another handler stops propagation.
  document.addEventListener('click', onCheckoutClick, true);
})();
